import { render, staticRenderFns } from "./WapApplySteps.vue?vue&type=template&id=4dd5f7d7&scoped=true&"
var script = {}
import style0 from "./WapApplySteps.vue?vue&type=style&index=0&id=4dd5f7d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5f7d7",
  null
  
)

export default component.exports